(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-search.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-search.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const ReactIcon = svs.ui.ReactIcon;
const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const HighscoreContext = svs.components.marketplaceCompetition.routeResult.highscore.HighscoreContext;
const selectCompetitionResultPending = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors.selectCompetitionResultPending;
const HighscoreSearch = _ref => {
  let ariaLabel = _ref.ariaLabel,
    description = _ref.description,
    _ref$minLength = _ref.minLength,
    minLength = _ref$minLength === void 0 ? 3 : _ref$minLength,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 500 : _ref$debounce,
    competitionId = _ref.competitionId;
  const _useContext = useContext(HighscoreContext),
    setSearchTerm = _useContext.setSearchTerm,
    _useContext$searchTer = _useContext.searchTerm,
    searchTerm = _useContext$searchTer === void 0 ? '' : _useContext$searchTer,
    type = _useContext.type,
    setOffset = _useContext.setOffset;
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const _useState = useState(searchTerm),
    _useState2 = _slicedToArray(_useState, 2),
    searchterm = _useState2[0],
    setSearchterm = _useState2[1];
  const lastSearchLength = useRef(searchTerm.length);
  const onSearchChange = useCallback(e => {
    setSearchterm(e.currentTarget.value);
    setOffset(0);
  }, [setOffset]);
  useEffect(() => {
    const searchTermLength = searchterm.length;
    const triggerSearch = () => {
      if (searchTermLength >= minLength && !listIsPending) {
        lastSearchLength.current = searchTermLength;
        setSearchTerm(searchterm);
        setOffset(0);
      }
    };
    const triggerClear = () => {
      lastSearchLength.current = searchTermLength;
      setSearchTerm('');
      setOffset(0);
    };
    const debounceTimer = setTimeout(() => {
      triggerSearch();
    }, debounce);
    if (searchTermLength === 0 && lastSearchLength.current > 0) {
      clearTimeout(debounceTimer);
      triggerClear();
    }
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchTerm, debounce, minLength, setSearchTerm, searchterm, listIsPending, setOffset]);
  return React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Inputv2, {
    "aria-label": ariaLabel,
    id: "reactAmount",
    inputHelpText: description,
    label: description,
    onChange: onSearchChange,
    suffix: React.createElement(ReactIcon, {
      icon: "search",
      size: "100"
    }),
    value: searchterm
  }));
};
HighscoreSearch.PropType = {
  ariaLabel: PropTypes.string,
  description: PropTypes.string,
  minLength: PropTypes.number,
  debounce: PropTypes.number,
  competitionId: PropTypes.number
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreSearch', HighscoreSearch);

 })(window);